function cov_1i3heakuf2() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LocationPin.tsx";
  var hash = "89328815f80177fd4db8c43b81778da955433fb0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LocationPin.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "89328815f80177fd4db8c43b81778da955433fb0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1i3heakuf2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1i3heakuf2();
var Icon = (cov_1i3heakuf2().s[0]++, {
  name: 'location-pin',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 18.7063L16.2426 14.4636C18.5858 12.1205 18.5858 8.32151 16.2426 5.97837C13.8995 3.63522 10.1005 3.63522 7.75736 5.97837C5.41421 8.32151 5.41421 12.1205 7.75736 14.4636L12 18.7063ZM18.0104 4.2106C14.691 0.891144 9.30905 0.891144 5.98959 4.2106C2.67014 7.53006 2.67014 12.912 5.98959 16.2314L12 22.2418L18.0104 16.2314C21.3299 12.912 21.3299 7.53006 18.0104 4.2106Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 11.5C12.8284 11.5 13.5 10.8284 13.5 10C13.5 9.17157 12.8284 8.5 12 8.5C11.1716 8.5 10.5 9.17157 10.5 10C10.5 10.8284 11.1716 11.5 12 11.5ZM12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14Z\" fill=\"currentColor\"/>"
});
export default Icon;